import React, {FC} from 'react'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {formatMonneyCompact} from '@/components/utils/number'

interface BalanceCellProps {
  balance: number
  currency: string
}

export const BalanceCell: FC<BalanceCellProps> = ({balance, currency}) => {
  const intl = useIntl()
  const formatted = intl.formatNumber(balance, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

  return (
    <div title={formatted}>
      {formatMonneyCompact(balance, currency)}
    </div>
  )
}

interface StatusCellProps {
  status: string
}

export const StatusCell: FC<StatusCellProps> = ({status}) => {
  const intl = useIntl()
  return (
    <div className={clsx('badge', {
      'badge-light-success': status === 'STATUS_ENABLED',
      'badge-light-danger': status === 'STATUS_DISABLED',
      'badge-light-warning': status === 'STATUS_ARCHIVED',
    })}>
      {intl.formatMessage({id: `P2C.SUPPLIER_${status}`})}
    </div>
  )
}
